import { User } from '@harlowe/core'


export namespace UserInterface
{
    export class LoggedIn
    {
        static readonly type = "[UI Login Action] User Logged In"
        constructor(public payload: { user: User }) {}
    }


    export class LoadRouteInSidebar
    {
        static readonly type = "[Router] Load Route in Sidebar";
        constructor(public payload: {route:string}){}
    }

    export class OpenSidebar
    {
        static readonly type="[App Component] Open Sidebar"
    }

    export class CloseSidebar
    {
        static readonly type="[Sidebar] Close Sidebar";
    }

    export class OpenEncounter
    {
        static readonly type="[EncounterManager] OpenEncounter";
    }

    export class SetTopMenuVisibility
    {
        static readonly type="[UI State] Set Top Menu Visibility";
        constructor(public payload: {show:boolean}){}
    }
}

